<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="user-chip"
          :color="getColor()"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          {{ id }} ({{ type.toUpperCase() }})
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Wallet ID
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'PaybackWalletChip',
  props: {
    id: {
      type: String,
      default: null,
      required: true,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentUser: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  methods: {
    onClick() {
      if (this.type === 'ddp') {
        this.$router.push('/dd/accounts');
      }
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `Wallet ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
    getColor() {
      switch (this.type) {
        case 'ddp':
          return 'primary';
        case 'sepa':
          return 'secondary';
        default:
          return 'error';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/PaybackWalletChip.vue